module.exports = __webpack_public_path__ + "static/media/menu-icon.dc6f70ea.svg";